// HOOKS
import { usePayment } from "src/hooks/context";
import { useUpdatePayment } from "src/hooks/useUpdatePayment";

// COMPONENTS
import SelectedBank from "src/components/SelectedBank/SelectedBank";
import { Cards } from "../Cards/Cards";
import TrafficLightSpinner from "@joinTrilo/ui/atoms/TrafficLightSpinner/TrafficLightSpinner";

// STYLES
import {
    StyledButtonWrapper,
    StyledAuthText,
    StyledAuthWrapper,
    StyledPayButton,
    StyledPaymentMethodWrapper,
    StyledChangeButton,
} from "./Pay.styled";
import SuccessfulIcon from "@joinTrilo/ui/atoms/Icon/Successful";
import Lock from "src/assets/icons/Lock";
import { useCallback, useEffect, useState } from "react";

export const ChoosePaymentMethod = ({
    authUrl,
    goToPaymentSummary
}: {
    authUrl?: string | null;
    goToPaymentSummary: (foreignId: string) => void;
}) => {
    const { paymentState, updatePaymentState } = usePayment();
    const [stripeConnectAccount, setStripeConnectAccount] = useState(null);
    const [showSuccess, setShowSuccess] = useState<boolean>(false);

    const { updatePayment } = useUpdatePayment();

    useEffect(() => {
        function findStripeConnectAccount() {
            if (paymentState.recipient?.features?.cardsSettings) {
                console.log(paymentState.recipient?.features?.cardsSettings);
                const cardsSettings = JSON.parse(
                    paymentState.recipient?.features?.cardsSettings
                );
                console.log(cardsSettings);
                setStripeConnectAccount(cardsSettings.id);
            }
        }
        findStripeConnectAccount();
    }, [paymentState.recipient?.features?.cardsSettings]);

    const onSuccessCards = useCallback(async () => {
        async function onSuccessFn() {
            setShowSuccess(true);
            await updatePayment({
                paymentId: paymentState.id,
                isSettled: true
            });
            console.log("[Cards] paymentState.foreignId", paymentState.foreignId);
            if (!paymentState.foreignId) {
                return null;
            }
            updatePaymentState({
                status: "PAID"
            });
            goToPaymentSummary(paymentState.foreignId);
        }
        onSuccessFn()
    }, [paymentState.id, paymentState.foreignId, updatePayment, goToPaymentSummary, updatePaymentState]);

    if (!paymentState || !paymentState.amount) {
        return null;
    }

    if (showSuccess) {
        return <PaymentSuccessful />;
    }

    const cardPaymentMethod =
        paymentState.paymentMethod &&
        paymentState.paymentMethod?.name === "Cards" &&
        !!stripeConnectAccount;

    const bankPaymentMethod =
        paymentState.paymentMethod &&
        paymentState.paymentMethod?.name !== "Cards";

    return (
        <StyledButtonWrapper>
            {paymentState.paymentMethod && (
                <StyledPaymentMethodWrapper
                    onClick={() => {
                        updatePaymentState({
                            paymentMethod: undefined,
                            paymentUrl: undefined,
                            paymentQrSrc: undefined,
                            // transferId: undefined,
                        });
                    }}
                >
                    <SelectedBank
                        name={paymentState.paymentMethod?.name}
                        logoUrl={paymentState.paymentMethod?.logo}
                        disabled={false}
                    />

                    <StyledChangeButton>Change</StyledChangeButton>
                </StyledPaymentMethodWrapper>
            )}
            {cardPaymentMethod && (
                <CardsScreen
                    stripeConnectAccount={stripeConnectAccount ?? undefined}
                    paymentAmount={paymentState.amount}
                    paymentNote={paymentState.note ?? "Digital Wallet Payment"}
                    paymentRecipientName={paymentState.recipient?.name}
                    clientSecret={paymentState.foreignId ?? undefined}
                    onSuccessCards={onSuccessCards}
                />
            )}

            {bankPaymentMethod && (
                <StyledAuthWrapper>
                    <StyledPayButton
                        href={authUrl ?? undefined}
                        target="_blank"
                        isDisabled={Boolean(!authUrl)}
                        isLoading={authUrl === null}
                    >
                        {authUrl === null ? (
                            <TrafficLightSpinner
                                direction="horizontal"
                                size={8}
                                color="deepGrey"
                            />
                        ) : (
                            <>
                                <Lock />
                                {`Pay ${paymentState.amount}`}
                            </>
                        )}
                    </StyledPayButton>

                    <StyledAuthText>
                        Trilo is authorised and regulated by the FCA.
                    </StyledAuthText>
                </StyledAuthWrapper>
            )}
        </StyledButtonWrapper>
    );
};

type CardsScreenProps = {
    stripeConnectAccount?: string;
    paymentAmount: string;
    paymentNote?: string;
    paymentRecipientName?: string;
    clientSecret?: string;
    onSuccessCards: () => void;
};

function CardsScreen({
    stripeConnectAccount,
    paymentAmount,
    paymentNote,
    paymentRecipientName,
    clientSecret,
    onSuccessCards,
}: CardsScreenProps) {
    return (
        <div style={{ width: "100%" }}>
            <Cards
                amount={Number(paymentAmount.replace(".", "").replace("£", ""))}
                description={
                    paymentNote ?? `Payment to ${paymentRecipientName}`
                }
                clientSecret={clientSecret ?? undefined}
                stripeConnect={stripeConnectAccount}
                onSuccess={onSuccessCards}
            />
        </div>
    );
}

function PaymentSuccessful() {
    return (
        <StyledButtonWrapper>
            <div style={{ margin: "0 auto" }}>
                <SuccessfulIcon />
            </div>
        </StyledButtonWrapper>
    );
}
